// extracted by mini-css-extract-plugin
export default {"content":"Root_content__thWxt","checkout":"Root_checkout__ndm81"};